import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlProps, MenuItem, Select, Checkbox, styled } from '@material-ui/core';

import { CustomFormControl, CustomInput, CustomInputLabel } from '../../../shared/components';

const ExerciseSeriesMultiSelectFormControl = styled(CustomFormControl)({
  marginLeft: '4rem',
  width: 'calc(100% - 4rem)',
});

type Props = Omit<FormControlProps, 'value' | 'onChange'> & {
  trajectoryId: string;
  value: string[];
  onChange: (value: string[]) => void;
  options: { id: string; label: string }[];
};

const ExerciseSeriesMultiSelect: FC<Props> = ({
  trajectoryId,
  value,
  onChange,
  options,
  ...props
}) => {
  const { t } = useTranslation();

  const handleSelectionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string[]);
  };

  const renderSelectedValues = useCallback(
    (selectedValues: unknown) => {
      return (selectedValues as string[])
        .map((selectedId) => {
          const series = options.find(({ id }) => id === selectedId);
          if (!series) return '';
          return series.label;
        })
        .filter(Boolean)
        .join(', ');
    },
    [options]
  );

  return (
    <ExerciseSeriesMultiSelectFormControl {...props}>
      <CustomInputLabel>{t('trajectory.sidebar.assignments.form.series')}</CustomInputLabel>
      <Select
        multiple
        input={<CustomInput />}
        renderValue={renderSelectedValues}
        value={value}
        onChange={handleSelectionChange}
      >
        {options.map(({ id, label }) => (
          <MenuItem key={id} value={id}>
            <Checkbox checked={value.indexOf(id) > -1} />
            {label}
          </MenuItem>
        ))}
      </Select>
    </ExerciseSeriesMultiSelectFormControl>
  );
};
export default ExerciseSeriesMultiSelect;
